jQuery.noConflict();
jQuery(document).ready(function($) {
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('ul.tabs li').each(function(i) {
	 var cl = ''; 
	 var attrb = $(this).attr("class");
	 if(typeof attrb !== 'undefined' && attrb !== false){
		cl = attrb; 
	 }
	 $(this).html('<a class="'+cl+'" href="#'+$(this).attr("rel")+'" ecocart-listener="true">'+$(this).html()+'</a>').removeClass('active'); 
    
  });  
  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $('.toggle').click(function() {
    if ($(window).width() <= 767) { 
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('+');
      } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('-');
      }
    }
  });

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on("submit", function (e) {
      
        $.ajax({
            type: $cf.attr('method'),
            url: $cf.attr('action'),
            data: $cf.serialize(),
            success: function (data) {
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            }
        });
        e.preventDefault();
      
      setTimeout($.fancybox.close, 3000);
    });
  });

  

  

  
    $( document ).ready(function() {
      var $target = $("#instafeed");
      $target.instagramLite({
        clientID: $target.data('client-id'),
        urls: true,
        videos: true,
        limit: $target.data('count'),
        error: function(errorCode, errorMessage) {
          if(errorCode && errorMessage) {
            alert(errorCode +': '+ errorMessage);
          } 
        }
        });
      });
    


  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function ajaxSubmitCart() {
    $cart = $("#cart");
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function refreshCart(cart) {
    $cartBtn = $(".icon-cart");
    if ($cartBtn) {
      var $cartCount = $cartBtn.find('.cart_count');
      var value = $cartCount.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      
      if($cartCount && $cartCount.size()) {
        $cartCount.text(value.replace(/[0-9]+/,cart.item_count));
      } else {
        $cartBtn.prepend('<div class="cart_count">' + cart.item_count + '</div>');
      }
      
      $cart.find('li:not(:first)').remove();

      if (cart.item_count == 0) {
        $cart.append('<li class="mm-label empty_cart"><a href="/cart">Your Cart is Empty</a></li>');
        $cartCount.remove();
      } else {
        $.each(cart.items, function(index, item) {
          cart_items_html += '<li class="cart_item">' +
            '<a href="' + item.url +'">';
          if (item.image) {
            cart_items_html += '<div class="cart_image">' +
                '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
              '</div>';
          }
          cart_items_html += '<div class="item_title">' + item.title +'</div>' +
              '<strong class="price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</strong>' +
              '<div class="quantity_selector">' +
                '<span class="minus">-</span><input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" /><span class="plus">+</span>' +
              '</div>' +
            '</a>' +
          '</li>';
        });

        cart_items_html += '<li class="mm-label">' +
            '<p class="mm-counter">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</p>' +
            '<a href="/cart">' +
              '<strong>Subtotal</strong>' +
            '</a>' +
          '</li>' +
          '<li class="mm-subtitle clearfix">';

           
            var cart_note = cart.note ? cart.note : '';
            cart_items_html += '<textarea id="note" name="note" rows="2" placeholder="Order Notes" class="clearfix">'+cart_note+'</textarea>';
          

          

          cart_items_html += '<input type="submit" class="action_button right" value="Checkout" />' +
            '<a href="/cart" class="action_button edit_cart left">Edit Cart</a>' +
          '</li>';

        $cart.append(cart_items_html);

        
      }
    }
  }

  $(document).on("change", "#cart input.quantity", function() { 
    ajaxSubmitCart();
  });

  $(document).on("click", ".quantity", function(e) { 
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
  $(document).on("click", ".minus", function(e) { 
    var quantity = parseInt($(this).next("input").val()); 
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    if (quantity == 0) {
      $(this).closest('li.cart_item').slideUp();
      setTimeout(ajaxSubmitCart, 500);
    } else {
      ajaxSubmitCart();
    }
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
  $(document).on("click", ".plus", function(e) { 
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
    ajaxSubmitCart();
    e.stopPropagation();
    e.preventDefault();
    return false;
  });

  

  selectCallback = function(variant, selector) {
    var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);

    if (variant && variant.featured_image && $product.is(":visible")) {
      var $sliders = $('.product_gallery', $product);
      $sliders.each(function() {
        var $slider = $(this);
        if ($slider.is(":visible")) {
          $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
        }
      });
    }

    if (variant) {
      $('.sku span', $product).text(variant.sku);
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

      
    }

    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')))        
      } else {
        $('.was_price', $product).text('')
      } 

      if (variant.inventory_management && variant.inventory_quantity > 0) {
        
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      } else {
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
      }

      $('.sold_out', $product).text('');
      if (variant.price > 0) {
        $('.current_price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
      } else {
        $('.current_price', $product).html("Free");
      }
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $notify_form.hide();
    } else {
      var message = variant ? "Sold out" : "Unavailable";
      $('.was_price', $product).text('');
      $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      $('.sold_out', $product).text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message); 
      $notify_form.fadeIn();
    }
    
    
  };          
});

function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }
}


/*!

Name: Instagram Lite
Dependencies: jQuery
Author: Michael Lynch
Author URL: http://michaelynch.com
Date Created: January 14, 2014
Licensed under the MIT license

*/
;(function($) {
    $.fn.instagramLite = function(options) {
    
    // return if no element was bound
    // so chained events can continue
    if(!this.length) { 
      return this; 
    }

    // define default parameters
        var defaults = {
            username: null,
            clientID: null,
            limit: null,
            list: true,
            videos: false,
            urls: false,
            captions: false,
            date: false,
            likes: false,
            max_id: null,
            loadMore: null,
            error: function() {},
            success: function() {}
        }
        
        // define plugin
        self.plugin = this;

        // define settings
        self.plugin.settings = {}
 
        // merge defaults and options
        self.plugin.settings = $.extend({}, defaults, options);

        // define element
        self.el = $(this);
       
        // init
        self.loadContent();
        
        // bind load more click event
        if(plugin.settings.loadMore){
          $(plugin.settings.loadMore).on('click',function(e){
            e.preventDefault();
            self.loadContent();
          });
        } 
    },
    
    getMaxId = function(items){
    
      // return id of last item
      return items[items.length-1].id;
    },
    
    formatCaption = function(caption) {
    
      var words = caption.split(' '),
        newCaption = '';
      
      for(var i = 0; i < words.length; i++) {        
        var word;
        
        if(words[i][0] == '@') {
          var a = '<a href="http://twitter.com/'+words[i].replace('@', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
          word = a;
        } else if(words[i][0] == '#') {
          var a = '<a href="http://twitter.com/hashtag/'+words[i].replace('#', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
          word = a;
        } else {
          word = words[i]
        }

        newCaption += word + ' ';
        
      }
    
      return newCaption;
      
    },
    
    loadContent = function(){

      // if client ID and username were provided
      if(plugin.settings.clientID) {
      
        // for each element
        el.each(function() {
          // construct API endpoint
          var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+plugin.settings.clientID+'&count='+plugin.settings.limit+'&callback=?';
          
          // concat max id if max id is set
          url += (plugin.settings.max_id) ? '&max_id='+plugin.settings.max_id : '';

              $.ajax({
                type: 'GET',
                url: url,
                dataType: 'jsonp',
                success: function(data) {
                  
                  // if success status
                  if(data.meta.code === 200 && data.data.length) {
                
                    // for each piece of media returned
                    for(var i = 0; i < data.data.length; i++) {
                    
                      // define media namespace
                      var thisMedia = data.data[i],
                        item;
                      
                      // if media type is image
                      if(thisMedia.type === 'image') {
                      
                        // construct image
                        item = '<img class="il-photo__img" src="'+thisMedia.images.standard_resolution.url+'" alt="Instagram Image" data-filter="'+thisMedia.filter+'" />';

                        // if url setting is true
                        if(plugin.settings.urls) {
                          item = '<a href="'+thisMedia.link+'" target="_blank">'+item+'</a>';
                        }
                        
                        if(plugin.settings.captions || plugin.settings.date || plugin.settings.likes) {
                          item += '<div class="il-photo__meta">';
                        }
                        
                        // if caption setting is true
                        if(plugin.settings.captions && thisMedia.caption) {
                        
                          item += '<div class="il-photo__caption" data-caption-id="'+thisMedia.caption.id+'">'+self.formatCaption(thisMedia.caption.text)+'</div>';
                          
                        }
                        
                        // if date setting is true
                        if(plugin.settings.date) {
                          var date = new Date(thisMedia.created_time * 1000),
                          day = date.getDate(),
                          month = date.getMonth() + 1,
                          year = date.getFullYear(),
                          hours = date.getHours(),
                          minutes = date.getMinutes(),
                          seconds = date.getSeconds();
                          date = month +'/'+ day +'/'+ year;
                          item += '<div class="il-photo__date">'+date+'</div>';
                        }
                        
                        // if likes setting is true
                        if(plugin.settings.likes) {
                          item += '<div class="il-photo__likes">'+thisMedia.likes.count+'</div>';
                        }
                        
                        if(plugin.settings.captions || plugin.settings.date || plugin.settings.likes) {
                          item += '</div>';
                        }
                      }
                      
                      if(thisMedia.type === 'video' && plugin.settings.videos) {
                        
                        if(thisMedia.videos) {
                          var src;
                          if(thisMedia.videos.standard_resolution) {
                            src = thisMedia.videos.standard_resolution.url;
                          } else if(thisMedia.videos.low_resolution) {
                            src = thisMedia.videos.low_resolution.url;
                          } else if(thisMedia.videos.low_bandwidth) {
                            src = thisMedia.videos.low_bandwidth.url;
                          }
                          
                          item = '<video poster="'+thisMedia.images.standard_resolution.url+'" controls>';
                          item += '<source src="'+src+'" type="video/mp4;"></source>';
                          item += '</video>';
                        }
                      }
                      
                      // if list setting is true
                      if(plugin.settings.list) {
                        var item="<div class=\"one-fifth column\">"+item+"</div>";
                      }

                      // append image
                      el.append(item); 
                    }
                    // set new max id
                    plugin.settings.max_id = self.getMaxId(data.data);
                    // execute success callback
                    plugin.settings.success.call(this);
                  
                  } else {
                    // execute error callback
                    plugin.settings.error.call(this, data.meta.code, data.meta.error_message);
                  }
                
                },
                error: function() {
                  // recent media ajax request failed
                  // execute error callback
                  plugin.settings.error.call(this);
                }
              });
        });        
      } else {
        alert('An Instagram Access Token is required to display Instagram profile images.');
      }
    }
})(jQuery);